module.exports = __webpack_public_path__ + "img/Noctiluca-3-mobile.7655a541.png";